(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-categorias"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarCategorias(contenedor) {
    if (contenedor.dataset.tmCategoriasIniciado === 'true') return;

    var carrusel = contenedor.querySelector('[data-carrusel]');
    if (!carrusel) return;

    contenedor.dataset.tmCategoriasIniciado = 'true';

    var flechaAnterior = contenedor.querySelector('[data-direccion="-1"]');
    var flechaSiguiente = contenedor.querySelector('[data-direccion="1"]');
    var indicador = contenedor.querySelector('.tm-categorias__indicador-progreso');

    function actualizarEstado() {
      var maximo = Math.max(0, carrusel.scrollWidth - carrusel.clientWidth);
      var posicion = Math.max(0, carrusel.scrollLeft);

      if (flechaAnterior) {
        flechaAnterior.disabled = posicion <= 2;
      }

      if (flechaSiguiente) {
        flechaSiguiente.disabled = posicion >= maximo - 2;
      }

      if (indicador) {
        var porcentaje = carrusel.scrollWidth > 0
          ? ((posicion + carrusel.clientWidth) / carrusel.scrollWidth) * 100
          : 100;

        indicador.style.width = Math.min(100, Math.max(0, porcentaje)) + '%';
      }
    }

    function desplazar(direccion) {
      var elemento = carrusel.querySelector('.tm-categorias__elemento');
      if (!elemento) return;

      var estilos = window.getComputedStyle(carrusel);
      var espacio = parseFloat(estilos.gap) || 0;
      var distancia = elemento.getBoundingClientRect().width + espacio;

      carrusel.scrollBy({
        left: distancia * direccion,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });
    }

    if (flechaAnterior) {
      flechaAnterior.addEventListener('click', function () {
        desplazar(-1);
      });
    }

    if (flechaSiguiente) {
      flechaSiguiente.addEventListener('click', function () {
        desplazar(1);
      });
    }

    carrusel.addEventListener('scroll', actualizarEstado, { passive: true });
    window.addEventListener('resize', actualizarEstado);

    if (typeof ResizeObserver !== 'undefined') {
      var observador = new ResizeObserver(actualizarEstado);
      observador.observe(carrusel);
    }

    actualizarEstado();
  }

  function iniciarTodas() {
    document.querySelectorAll('.tm-categorias').forEach(iniciarCategorias);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    evento.target.querySelectorAll('.tm-categorias').forEach(iniciarCategorias);

    if (evento.target.matches && evento.target.matches('.tm-categorias')) {
      iniciarCategorias(evento.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-category-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.dataset.tmProductosIniciado === 'true') return;

    var carrusel = seccion.querySelector('[data-tm-carrusel]');
    if (!carrusel) return;

    seccion.dataset.tmProductosIniciado = 'true';

    var anterior = seccion.querySelector('[data-tm-anterior]');
    var siguiente = seccion.querySelector('[data-tm-siguiente]');
    var progreso = seccion.querySelector('[data-tm-progreso]');

    function limite() {
      return Math.max(0, carrusel.scrollWidth - carrusel.clientWidth);
    }

    function actualizar() {
      var maximo = limite();
      var posicion = Math.max(0, carrusel.scrollLeft);

      if (anterior) anterior.disabled = posicion <= 2;
      if (siguiente) siguiente.disabled = posicion >= maximo - 2;

      if (progreso) {
        var porcentaje = carrusel.scrollWidth > 0
          ? (posicion + carrusel.clientWidth) / carrusel.scrollWidth * 100
          : 100;

        progreso.style.width = Math.min(100, Math.max(0, porcentaje)) + '%';
      }
    }

    function mover(direccion) {
      var tarjetas = Array.from(carrusel.querySelectorAll('.tm-productos__tarjeta'));
      if (!tarjetas.length) return;

      var maximo = limite();
      var posicion = Math.max(0, carrusel.scrollLeft);
      var tolerancia = 3;
      var destino = posicion;

      if (direccion > 0) {
        var siguienteTarjeta = tarjetas.find(function (tarjeta) {
          return tarjeta.offsetLeft - carrusel.offsetLeft > posicion + tolerancia;
        });

        destino = siguienteTarjeta
          ? siguienteTarjeta.offsetLeft - carrusel.offsetLeft
          : maximo;

        if (destino > maximo || !siguienteTarjeta) {
          destino = maximo;
        }
      } else {
        var anteriores = tarjetas.filter(function (tarjeta) {
          return tarjeta.offsetLeft - carrusel.offsetLeft < posicion - tolerancia;
        });

        destino = anteriores.length
          ? anteriores[anteriores.length - 1].offsetLeft - carrusel.offsetLeft
          : 0;
      }

      carrusel.scrollTo({
        left: Math.max(0, Math.min(maximo, destino)),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });
    }

    if (anterior) {
      anterior.addEventListener('click', function () {
        mover(-1);
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        mover(1);
      });
    }

    carrusel.addEventListener('scroll', actualizar, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var observador = new ResizeObserver(actualizar);
      observador.observe(carrusel);
    }

    actualizar();
  }

  function iniciarTodas(raiz) {
    raiz.querySelectorAll('.tm-productos').forEach(iniciar);

    if (raiz.matches && raiz.matches('.tm-productos')) {
      iniciar(raiz);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas(document);
    });
  } else {
    iniciarTodas(document);
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-videos-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (seccion.dataset.tmVideosIniciado === 'true') return;

    var carrusel = seccion.querySelector('[data-tm-carrusel]');
    var modal = seccion.querySelector('[data-tm-modal]');

    if (!carrusel || !modal) return;

    seccion.dataset.tmVideosIniciado = 'true';

    var anterior = seccion.querySelector('[data-tm-anterior]');
    var siguiente = seccion.querySelector('[data-tm-siguiente]');
    var progreso = seccion.querySelector('[data-tm-progreso]');
    var contenedorVideo = modal.querySelector('[data-tm-modal-media]');
    var contenedorImagen = modal.querySelector('[data-tm-modal-miniatura]');
    var botonSonido = modal.querySelector('[data-tm-sonido]');
    var botonReproducir = modal.querySelector('[data-tm-reproducir]');
    var panel = modal.querySelector('.tm-videos__modal-panel');

    var videos = Array.from(
      seccion.querySelectorAll('.tm-videos__video')
    );

    var videoModal = null;
    var marcadorOriginal = null;
    var ultimoFoco = null;
    var bloqueoAnterior = '';
    var desplazamientoPendiente = false;
    var finDesplazamiento = null;

    var movimientoReducido = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function marcarListo() {
        if (video.readyState >= 2) {
          video.classList.add('tm-videos__video--listo');
        }
      }

      video.addEventListener('loadeddata', marcarListo);
      video.addEventListener('playing', marcarListo);

      video.addEventListener('error', function () {
        video.classList.remove('tm-videos__video--listo');
      });

      marcarListo();
    });

    function pausarCarrusel() {
      videos.forEach(function (video) {
        if (video !== videoModal && !video.paused) {
          video.pause();
        }
      });
    }

    function reproducirVisibles() {
      if (
        modal.classList.contains('tm-videos__modal--abierto') ||
        document.hidden ||
        movimientoReducido.matches
      ) {
        pausarCarrusel();
        return;
      }

      var area = carrusel.getBoundingClientRect();

      videos.forEach(function (video) {
        if (video === videoModal) return;

        var rect = video.getBoundingClientRect();

        var anchoVisible = Math.max(
          0,
          Math.min(rect.right, area.right) -
          Math.max(rect.left, area.left)
        );

        var porcentaje = rect.width > 0
          ? anchoVisible / rect.width
          : 0;

        var visibleVertical =
          rect.bottom > 0 &&
          rect.top < window.innerHeight;

        var visible =
          porcentaje >= 0.5 &&
          visibleVertical;

        if (!visible) {
          if (!video.paused) video.pause();
          return;
        }

        if (!video.paused) return;
        if (video.dataset.tmIntentando === 'true') return;
        if (video.dataset.tmBloqueado === 'true') return;

        video.dataset.tmIntentando = 'true';

        var intento;

        try {
          intento = video.play();
        } catch (error) {
          video.dataset.tmIntentando = 'false';
          video.dataset.tmBloqueado = 'true';
          return;
        }

        if (intento && typeof intento.then === 'function') {
          intento.then(function () {
            video.dataset.tmIntentando = 'false';
          }).catch(function () {
            video.dataset.tmIntentando = 'false';
            video.dataset.tmBloqueado = 'true';
          });
        } else {
          video.dataset.tmIntentando = 'false';
        }
      });
    }

    function actualizar() {
      var maximo = Math.max(
        0,
        carrusel.scrollWidth - carrusel.clientWidth
      );

      var posicion = Math.max(0, carrusel.scrollLeft);

      if (anterior) {
        anterior.disabled = posicion <= 2;
      }

      if (siguiente) {
        siguiente.disabled = posicion >= maximo - 2;
      }

      if (progreso) {
        var porcentaje = carrusel.scrollWidth > 0
          ? (posicion + carrusel.clientWidth) /
            carrusel.scrollWidth * 100
          : 100;

        progreso.style.width =
          Math.min(100, Math.max(0, porcentaje)) + '%';
      }
    }

    function mover(direccion) {
      var tarjeta = carrusel.querySelector('.tm-videos__tarjeta');

      if (!tarjeta) return;

      var distancia =
        tarjeta.getBoundingClientRect().width +
        (parseFloat(getComputedStyle(carrusel).gap) || 0);

      carrusel.scrollBy({
        left: direccion * distancia,
        behavior: movimientoReducido.matches ? 'auto' : 'smooth'
      });
    }

    function actualizarSonido() {
      if (!videoModal) return;

      var activo = !videoModal.muted;

      botonSonido.setAttribute(
        'aria-pressed',
        activo ? 'true' : 'false'
      );

      botonSonido.setAttribute(
        'aria-label',
        activo ? 'Silenciar video' : 'Activar sonido'
      );
    }

    function actualizarReproduccion() {
      botonReproducir.hidden =
        !videoModal || !videoModal.paused;
    }

    function reproducirModal() {
      if (!videoModal) return;

      var actual = videoModal;

      actual.playsInline = true;
      actual.setAttribute('playsinline', '');
      actual.setAttribute('webkit-playsinline', '');

      var intento;

      try {
        intento = actual.play();
      } catch (error) {
        actualizarReproduccion();
        return;
      }

      if (intento && typeof intento.then === 'function') {
        intento.then(function () {
          if (videoModal === actual) {
            actualizarReproduccion();
          }
        }).catch(function () {
          if (videoModal !== actual) return;

          actual.muted = true;
          actualizarSonido();

          var segundoIntento = actual.play();

          if (
            segundoIntento &&
            typeof segundoIntento.then === 'function'
          ) {
            segundoIntento.then(function () {
              if (videoModal === actual) {
                actualizarReproduccion();
              }
            }).catch(function () {
              if (videoModal === actual) {
                actualizarReproduccion();
              }
            });
          }
        });
      } else {
        actualizarReproduccion();
      }
    }

    function abrirModal(escena) {
      var video = escena.querySelector('.tm-videos__video');

      if (!video) return;

      ultimoFoco = document.activeElement;

      pausarCarrusel();

      contenedorVideo.replaceChildren();
      contenedorImagen.replaceChildren();

      var urlImagen = escena.dataset.tmImagen || '';

      if (urlImagen) {
        var imagen = document.createElement('img');

        imagen.alt = escena.dataset.tmImagenAlt || '';
        imagen.loading = 'eager';
        imagen.decoding = 'async';
        imagen.width = 120;
        imagen.height = 120;
        imagen.src = urlImagen;

        imagen.addEventListener('error', function () {
          imagen.remove();
        });

        contenedorImagen.appendChild(imagen);
      }

      modal.querySelector(
        '[data-tm-modal-titulo]'
      ).textContent = escena.dataset.tmNombre || '';

      modal.querySelector(
        '[data-tm-modal-descripcion]'
      ).textContent = escena.dataset.tmDescripcion || '';

      modal.querySelector(
        '[data-tm-modal-nombre]'
      ).textContent = escena.dataset.tmNombre || '';

      modal.querySelector(
        '[data-tm-modal-precio]'
      ).textContent = escena.dataset.tmPrecio || '';

      var boton = modal.querySelector('[data-tm-modal-boton]');
      var enlace = escena.dataset.tmEnlace || '';
      var texto = escena.dataset.tmBoton || 'Descubrir juego';

      boton.href = enlace || '#';
      boton.hidden = !enlace;

      modal.querySelector(
        '[data-tm-modal-boton-texto]'
      ).textContent = texto;

      marcadorOriginal = document.createComment(
        'tm-video-posicion-original'
      );

      video.parentNode.insertBefore(
        marcadorOriginal,
        video
      );

      contenedorVideo.appendChild(video);

      videoModal = video;

      videoModal.classList.add('tm-videos__modal-video');
      videoModal.muted = true;
      videoModal.defaultMuted = true;
      videoModal.controls = false;
      videoModal.loop = true;
      videoModal.playsInline = true;
      videoModal.preload = 'auto';

      videoModal.setAttribute('playsinline', '');
      videoModal.setAttribute('webkit-playsinline', '');

      modal.removeAttribute('inert');
      modal.classList.add('tm-videos__modal--abierto');
      modal.setAttribute('aria-hidden', 'false');

      bloqueoAnterior = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      botonReproducir.hidden = true;

      actualizarSonido();
      reproducirModal();

      panel.focus({ preventScroll: true });
    }

    function cerrarModal() {
      if (!modal.classList.contains(
        'tm-videos__modal--abierto'
      )) return;

      if (videoModal) {
        videoModal.pause();
        videoModal.muted = true;
        videoModal.classList.remove('tm-videos__modal-video');

        if (marcadorOriginal && marcadorOriginal.parentNode) {
          marcadorOriginal.parentNode.insertBefore(
            videoModal,
            marcadorOriginal
          );

          marcadorOriginal.remove();
        }

        videoModal = null;
        marcadorOriginal = null;
      }

      modal.classList.remove('tm-videos__modal--abierto');
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');

      document.body.style.overflow = bloqueoAnterior;

      if (ultimoFoco && ultimoFoco.isConnected) {
        ultimoFoco.focus({ preventScroll: true });
      }

      reproducirVisibles();
    }

    seccion.querySelectorAll('[data-tm-abrir]').forEach(
      function (boton) {
        boton.addEventListener('click', function () {
          var escena = boton.closest('[data-tm-escena]');

          if (escena) abrirModal(escena);
        });
      }
    );

    modal.querySelectorAll('[data-tm-cerrar]').forEach(
      function (boton) {
        boton.addEventListener('click', cerrarModal);
      }
    );

    botonSonido.addEventListener('click', function () {
      if (!videoModal) return;

      videoModal.muted = !videoModal.muted;
      actualizarSonido();

      if (videoModal.paused) {
        reproducirModal();
      }
    });

    botonReproducir.addEventListener(
      'click',
      reproducirModal
    );

    contenedorVideo.addEventListener('click', function (evento) {
      if (
        videoModal &&
        evento.target === videoModal &&
        videoModal.paused
      ) {
        reproducirModal();
      }
    });

    modal.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') {
        cerrarModal();
        return;
      }

      if (evento.key !== 'Tab') return;

      var elementos = Array.from(
        modal.querySelectorAll(
          'button:not([disabled]), a[href]'
        )
      ).filter(function (elemento) {
        return (
          elemento.getClientRects().length > 0 &&
          !elemento.hidden
        );
      });

      if (!elementos.length) return;

      var primero = elementos[0];
      var ultimo = elementos[elementos.length - 1];

      if (
        evento.shiftKey &&
        document.activeElement === primero
      ) {
        evento.preventDefault();
        ultimo.focus();
      } else if (
        !evento.shiftKey &&
        document.activeElement === ultimo
      ) {
        evento.preventDefault();
        primero.focus();
      }
    });

    if (anterior) {
      anterior.addEventListener('click', function () {
        mover(-1);
      });
    }

    if (siguiente) {
      siguiente.addEventListener('click', function () {
        mover(1);
      });
    }

    carrusel.addEventListener('scroll', function () {
      if (!desplazamientoPendiente) {
        desplazamientoPendiente = true;

        requestAnimationFrame(function () {
          actualizar();
          desplazamientoPendiente = false;
        });
      }

      clearTimeout(finDesplazamiento);

      finDesplazamiento = setTimeout(function () {
        reproducirVisibles();
      }, 150);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pausarCarrusel();

        if (videoModal) {
          videoModal.pause();
        }
      } else {
        reproducirVisibles();
      }
    });

    if (typeof IntersectionObserver !== 'undefined') {
      var observador = new IntersectionObserver(
        function () {
          reproducirVisibles();
        },
        {
          threshold: [0, 0.25, 0.5, 0.75]
        }
      );

      observador.observe(seccion);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var observadorTamano = new ResizeObserver(function () {
        actualizar();
        reproducirVisibles();
      });

      observadorTamano.observe(carrusel);
    }

    window.addEventListener('resize', function () {
      actualizar();
      reproducirVisibles();
    }, { passive: true });

    actualizar();
    reproducirVisibles();
  }

  function iniciarTodas(raiz) {
    if (
      raiz.matches &&
      raiz.matches('.tm-videos')
    ) {
      iniciar(raiz);
    }

    raiz.querySelectorAll('.tm-videos').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarTodas(document);
    });
  } else {
    iniciarTodas(document);
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarTodas(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
